import {ActionList} from '@primer/react'

export interface ChangeGroupsPreferencesProps {
  changeGroupsPreferenceAvailable: boolean
  showChangeGroups: boolean
  onShowChangeGroupsChange: (value: boolean) => void
}

// Returns the JSX for change groups preferences to be used in ActionList menus.
export function ChangeGroupsPreferences({
  changeGroupsPreferenceAvailable,
  showChangeGroups,
  onShowChangeGroupsChange,
}: ChangeGroupsPreferencesProps): React.ReactNode {
  if (!changeGroupsPreferenceAvailable) {
    return undefined
  }

  return (
    <>
      <ActionList.Divider />
      <ActionList.Group aria-label="Change Groups" selectionVariant="single">
        <ActionList.Item selected={showChangeGroups} onSelect={() => onShowChangeGroupsChange(!showChangeGroups)}>
          Show changes by group
          <ActionList.Description variant="block">Organize changes into groups with Copilot</ActionList.Description>
        </ActionList.Item>
      </ActionList.Group>
    </>
  )
}

try{ ChangeGroupsPreferences.displayName ||= 'ChangeGroupsPreferences' } catch {}